import React from 'react';
import NavigationItems from '../navigationItems/navigationItems';
import './sideDrawer.css';
import Backdrop from '../../ui/backdrop/backdrop';
import Aux from '../../../hoc/aux/aux';

const sideDrawer = ( props ) => {
  let attachedClasses = ["SideDrawer", "Close"];
  if (props.open) {
    attachedClasses = ["SideDrawer", "Open"];
  }

  return (
    <Aux>
      <Backdrop show={props.open} clicked={props.closed}/>
      <div className={attachedClasses.join(' ')}>
        <nav>
          <NavigationItems clicked={props.closed}/>
        </nav>
      </div>
    </Aux>
    
  );
}

export default sideDrawer;
